var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("AidApplication.BasicInfo.OperationName")))
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("AidApplication.BasicInfo.Purpose")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(_vm._s(_vm.$t("AidApplication.BasicInfo.Purpose_Instructions")))
    ]),
    _vm._v(" "),
    !_vm.isAy || !_vm.isExtension
      ? _c("div", [
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
          _vm._v(" "),
          _c("p", { staticClass: "question" }, [
            _vm._v(_vm._s(_vm.$t("AidApplication.BasicInfo.StartTime")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("AidApplication.BasicInfo.StartTime_Instructions"))
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isAy
      ? _c("div", [
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
          _vm._v(" "),
          _c("p", { staticClass: "question" }, [
            _vm._v(_vm._s(_vm.$t("AidApplication.BasicInfo.EndTime")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("AidApplication.BasicInfo.EndTime_Instructions"))
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("AidApplication.BasicInfo.Location.Title")))
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t("AidApplication.BasicInfo.Location.Selection.Municipality")
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidApplication.BasicInfo.Municipalities.Title_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidApplication.BasicInfo.Location.Selection.WellbeingServiceCounties"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidApplication.BasicInfo.WellbeingServiceCounties.Title_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(_vm.$t("AidApplication.BasicInfo.Location.Selection.Abroad"))
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidApplication.BasicInfo.Location.Selection.Abroad_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t("AidApplication.BasicInfo.Location.Selection.Nationwide")
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidApplication.BasicInfo.Location.Selection.Nationwide_Instructions"
              )
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    !_vm.isAy
      ? _c("div", [
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
          _vm._v(" "),
          _c("p", { staticClass: "question" }, [
            _vm._v(_vm._s(_vm.$t("AidApplication.BasicInfo.Channel.Title")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("AidApplication.BasicInfo.Channel.Title_Instructions")
              )
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                _vm._s(
                  _vm.$t("AidApplication.BasicInfo.Channel.Selection.Phone")
                )
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(
                  _vm.$t("AidApplication.BasicInfo.Channel.Selection.Online")
                )
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(
                  _vm.$t("AidApplication.BasicInfo.Channel.Selection.Chat")
                )
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t("AidApplication.BasicInfo.OtherOperation.HasOtherOperation")
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "AidApplication.BasicInfo.OtherOperation.HasOtherOperation_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(_vm.$t("AidApplication.BasicInfo.OtherOperation.Items.Title"))
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "AidApplication.BasicInfo.OtherOperation.Items.Title_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidApplication.BasicInfo.OtherOperation.Items.Columns.Financing"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div")
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidApplication.BasicInfo.OtherOperation.Items.Columns.Specifier"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div")
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidApplication.BasicInfo.OtherOperation.Items.Columns.StartTime"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidApplication.BasicInfo.OtherOperation.Items.Columns.StartTime_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidApplication.BasicInfo.OtherOperation.Items.Columns.EndTime"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidApplication.BasicInfo.OtherOperation.Items.Columns.EndTime_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidApplication.BasicInfo.OtherOperation.Items.Columns.AidAmount"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div")
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "AidApplication.BasicInfo.OtherOperation.Items.Columns.Revenue"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }